import { Box } from 'app/design/primitives/box';
import type { ViewStyle } from 'react-native';
import { View } from 'react-native';
import type { IntroModalItem } from './intro-modal';

export function IntroCarouselDots({
  activeTab,
  carouselItems,
  dotActiveStyle,
  dotStyle,
  isSmallUI,
}: {
  activeTab: IntroModalItem | undefined;
  carouselItems: IntroModalItem[];
  dotActiveStyle: ViewStyle;
  dotStyle: ViewStyle;
  isSmallUI: boolean;
}) {
  if (carouselItems.length <= 1) return null;
  const activeIndex = carouselItems.findIndex((item) => item.id === activeTab?.id);
  return (
    <Box
      alignSelf="center"
      flex={0}
      flexDirection="row"
      marginTop="spacing.general.x2"
      marginBottom={isSmallUI ? 'spacing.general.0' : 'spacing.general.x4'}
    >
      {carouselItems.map((item, index) => (
        <View key={item.id} style={[dotStyle, activeIndex === index ? dotActiveStyle : null]} />
      ))}
    </Box>
  );
}
